import { useCallback, useEffect, useState } from "react";
import { blogService } from "../../../services/api";

/**
 * Artículos publicados del blog (los administra marketing desde el admin).
 * @param {{ limit?: number, page?: number }} [params]
 */
export default function useBlogPosts({ limit, page } = {}) {
  const [posts, setPosts] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    blogService.list({ limit, page }).then((res) => {
      if (cancelled) return;
      setPosts(res.data);
      setCount(res.count);
      setFailed(!res.ok);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [limit, page, reloadKey]);

  const reload = useCallback(() => setReloadKey((k) => k + 1), []);

  return { posts, count, loading, failed, reload };
}
